import { CreditReportService } from './credit-report.service';

export const services: any[] = [CreditReportService];

export * from './credit-report.service';
